export default __webpack_public_path__ + "static/media/frog_R1_C3.98427e54.png";